// import { useLanguage } from "../../../context/LanguageProvider";
// import React, { Fragment, useContext, useState } from "react";
// import { buyProducts } from "../../../actions";
// import { CarContext, CarDispatchContext } from "../../../context/CarContext";
// import {
//     Button,
//     Card,
//     CardActions,
//     CardContent,
//     CardHeader,
//     Typography,
//     useTheme,
// } from "@mui/material";
// import {
//     BUYING_ACTION,
//     FINISHED_BUYING_ACTION,
//     TYPE_PRODUCT,
//     DELETE_SHOP_CAR_PRODUCT,
// } from "../../../actions/constants";
// import ItemShopCar from "../ItemShopCar";
// import LocalMallOutlinedIcon from "@mui/icons-material/LocalMallOutlined";
// import { BuyingContext, BuyingDispatchContext } from "../../../context/BuyingContext";
// import ClassNameGenerator from "@mui/utils/ClassNameGenerator";

// const ProductTab = (props) => {
//     const { languageState } = useLanguage();

//     const [anchorEl, setAnchorEl] = useState(null);

//     const context = useContext(CarContext);
//     const dispatch = useContext(CarDispatchContext);

//     const buying = useContext(BuyingContext);
//     const dispatchBuying = useContext(BuyingDispatchContext);

//     const theme = useTheme();

//     const buyProductsCar = () => {
//         dispatchBuying({
//             type: BUYING_ACTION,
//         });
//         buyProducts({
//             data: {
//                 tipo: TYPE_PRODUCT,
//                 productos: context.map((e) => {
//                     return {
//                         id: parseInt(e.id),
//                         cantidad: e.cant,
//                     };
//                 }),
//                 fecha: new Date().toDateString(),
//             },
//         })
//             .then((resp) => {
//                 console.log(resp)
//                 window.location.replace(resp.data.stripeSession.url);
//             })
//             .catch((err) => console.log(err))
//             .finally(() => {
//                 dispatchBuying({
//                     type: FINISHED_BUYING_ACTION,
//                 });
//             });
//     };

//     return (
//         <>
//             <Card sx={{ minWidth: 300, height: "100%", boxShadow: "none" }}>
//                 <CardContent
//                     sx={{
//                         padding: "5px",
//                         overflow: "auto",
//                         maxHeight: "100%",
//                         paddingBottom: "52px",
//                     }}
//                 >
//                     {context?.map((e) => (
//                         <ItemShopCar
//                             key={e.id}
//                             product={e}
//                             actionDelete={DELETE_SHOP_CAR_PRODUCT}
//                             contextAction={CarDispatchContext}
//                         />
//                     ))}
//                 </CardContent>
//                 <CardActions
//                     sx={{
//                         minWidth: 300,
//                         position: "fixed",
//                         bottom: 0,
//                         right: 0,
//                         borderTopColor: "#fff",
//                         borderTop: "solid",
//                         borderTopWidth: "thin",
//                         background: theme.palette.background.paper,
//                     }}
//                 >
//                     <Button
//                         sx={{
//                             width: "100%",
//                             backgroundColor: "#f15a24",
//                             color: "#fff",
//                             "&:hover": {
//                                 transition: "transform 500ms ease !important",
//                                 backgroundColor: "rgba(241,90,36,0.45)",
//                             },
//                         }}
//                         disabled={context?.length === 0 || buying}
//                         onClick={buyProductsCar}
//                         startIcon={<LocalMallOutlinedIcon />}
//                     >
//                         {buying
//                             ? languageState.texts.ShopCar.button.loading
//                             : languageState.texts.ShopCar.button.title}
//                     </Button>
//                 </CardActions>
//             </Card>
//         </>
//     );
// };

// export default ProductTab;
import { useLanguage } from "../../../context/LanguageProvider";
import React, { Fragment, useContext, useState } from "react";
import { buyProducts, buyProductsPaypal } from "../../../actions";
import { CarContext, CarDispatchContext } from "../../../context/CarContext";
import {
    Button,
    Card,
    CardActions,
    CardContent,
    Typography,
    Modal,
    Box,
    useTheme,
} from "@mui/material";
import {
    BUYING_ACTION,
    FINISHED_BUYING_ACTION,
    TYPE_PRODUCT,
    DELETE_SHOP_CAR_PRODUCT,
} from "../../../actions/constants";
import ItemShopCar from "../ItemShopCar";
import LocalMallOutlinedIcon from "@mui/icons-material/LocalMallOutlined";
import { BuyingContext, BuyingDispatchContext } from "../../../context/BuyingContext";
import StripeIcon from '@mui/icons-material/Payment'; // Puedes cambiar este ícono si quieres
import PaypalIcon from '@mui/icons-material/AccountBalanceWallet'; // Simula Paypal, porque no hay icono oficial

const styleModal = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 300,
    bgcolor: 'background.paper',
    border: '2px solid #f15a24',
    boxShadow: 24,
    p: 4,
    borderRadius: 2,
    textAlign: "center",
};

const ProductTab = (props) => {
    const { languageState } = useLanguage();
    const [anchorEl, setAnchorEl] = useState(null);
    const [openModal, setOpenModal] = useState(false);
    const [selectedPayment, setSelectedPayment] = useState(null);

    const context = useContext(CarContext);
    const dispatch = useContext(CarDispatchContext);

    const buying = useContext(BuyingContext);
    const dispatchBuying = useContext(BuyingDispatchContext);

    const theme = useTheme();

    const handleOpenModal = () => setOpenModal(true);
    const handleCloseModal = () => setOpenModal(false);

    const handleSelectPayment = (method) => {
        setSelectedPayment(method);
        handleCloseModal();
        buyProductsCar(method);
    };

    const buyProductsCar = (paymentMethod) => {
        dispatchBuying({
            type: BUYING_ACTION,
        });
        if(paymentMethod == 'paypal'){
            buyProductsPaypal({
                data: {
                    tipo: TYPE_PRODUCT,
                    productos: context.map((e) => ({
                        id: parseInt(e.id),
                        cantidad: e.cant,
                    })),
                    fecha: new Date().toDateString(),
                    // metodoPago: paymentMethod, // aquí va el método de pago seleccionado
                },
            })
                .then((resp) => {
                    console.log(resp);
                    window.location.replace(resp.data.link.href);
                })
                .catch((err) => console.log(err))
                .finally(() => {
                    dispatchBuying({
                        type: FINISHED_BUYING_ACTION,
                    });
                });
        } else {
            buyProducts({
                data: {
                    tipo: TYPE_PRODUCT,
                    productos: context.map((e) => ({
                        id: parseInt(e.id),
                        cantidad: e.cant,
                    })),
                    fecha: new Date().toDateString(),
                    // metodoPago: paymentMethod, // aquí va el método de pago seleccionado
                },
            })
                .then((resp) => {
                    console.log(resp);
                    window.location.replace(resp.data.stripeSession.url);
                })
                .catch((err) => console.log(err))
                .finally(() => {
                    dispatchBuying({
                        type: FINISHED_BUYING_ACTION,
                    });
                });
        }
       
    };

    return (
        <>
            <Card sx={{ minWidth: 300, height: "100%", boxShadow: "none" }}>
                <CardContent
                    sx={{
                        padding: "5px",
                        overflow: "auto",
                        maxHeight: "100%",
                        paddingBottom: "52px",
                    }}
                >
                    {context?.map((e) => (
                        <ItemShopCar
                            key={e.id}
                            product={e}
                            actionDelete={DELETE_SHOP_CAR_PRODUCT}
                            contextAction={CarDispatchContext}
                        />
                    ))}
                </CardContent>
                <CardActions
                    sx={{
                        minWidth: 300,
                        position: "fixed",
                        bottom: 0,
                        right: 0,
                        borderTopColor: "#fff",
                        borderTop: "solid",
                        borderTopWidth: "thin",
                        background: theme.palette.background.paper,
                    }}
                >
                    <Button
                        sx={{
                            width: "100%",
                            backgroundColor: "#f15a24",
                            color: "#fff",
                            "&:hover": {
                                transition: "transform 500ms ease !important",
                                backgroundColor: "rgba(241,90,36,0.45)",
                            },
                        }}
                        disabled={context?.length === 0 || buying}
                        onClick={handleOpenModal}
                        startIcon={<LocalMallOutlinedIcon />}
                    >
                        {buying
                            ? languageState.texts.ShopCar.button.loading
                            : languageState.texts.ShopCar.button.title}
                    </Button>
                </CardActions>
            </Card>

            {/* Modal para elegir método de pago */}
            {openModal && (
    <Box sx={{
        ...styleModal,
        position: 'relative',
        top: 'auto',
        left: 'auto',
        transform: 'none',
        mt: 2,
        border: '2px solid #f15a24',
        backgroundColor: theme.palette.background.paper,
    }}>
    <Typography id="payment-method-title" variant="h6" component="h2" mb={2}>
            {languageState?.texts?.ShopCar?.modal?.title || "Selecciona método de pago"}
        </Typography>
        <Button
            variant="outlined"
            startIcon={<StripeIcon />}
            sx={{
                mb: 2,
                width: '100%',
                color: '#000',
                borderColor: '#f15a24',
                '&:hover': {
                    backgroundColor: '#f15a24',
                    color: '#fff',
                    borderColor: '#f15a24',
                },
            }}
            onClick={() => handleSelectPayment('stripe')}
        >
            Stripe
        </Button>
        <Button
            variant="outlined"
            startIcon={<PaypalIcon />}
            sx={{
                width: '100%',
                color: '#000',
                borderColor: '#0070ba',
                '&:hover': {
                    backgroundColor: '#0070ba',
                    color: '#fff',
                    borderColor: '#0070ba',
                },
            }}
            onClick={() => handleSelectPayment('paypal')}
        >
            PayPal
        </Button>
    </Box>
)}
        </>
    );
};

export default ProductTab;
